const formatItem = (item) => ({ link: item.value, note: item.type });

export default {
  computed: {
    formattedItems() {
      return this.items.map(formatItem);
    },
  },
};
